
<template>
  <div class="resume-container">
		<embed class="resume" :src="`${publicPath}/LucasDrummondResume.pdf`"/>
	</div>
</template>
<script>
  export default {
    name: 'Resume',
    data() {
      return {
        publicPath: process.env.BASE_URL
      }
    }
  }
</script>

<style lang="sass" scoped>
.resume
  position: absolute
  top: 0

</style>




